/**
 * Shared first element for every tenant-scoped TanStack Query key
 * (ADR-026 Addendum, AO-9). Lets a single `removeQueries` call at
 * switch/logout time clear all tenant-scoped cache regardless of which
 * organization it belonged to, independent of the organization id each
 * key also embeds.
 */
export const TENANT_QUERY_PREFIX = 'tenant' as const;
